import { useAudiovisual, useFragment } from "@/hooks/api/useFragment";
import { getPosterframe } from "@/utils/dedaloUtils";

export default function VideoCard ({ locator, selectVideo }) {
    const { data: audiovisualData, error: audiovisualError } = useAudiovisual(locator.section_id);
    const { data, error } = useFragment(locator);

    const title = audiovisualData?.[0]?.title || null;
    const posterframeUrl = data?.posterframe_url ? getPosterframe(data.posterframe_url) : null;
    const videoUrl = data?.video_url || null;
    const subtitlesUrl = data?.subtitles_url || null;
    const transcription = data?.fragm ? data.fragm : null;
    const videoInfo = { posterframeUrl, videoUrl, subtitlesUrl, title }

    function shortenText(text, maxLength) {
        if (!text || text.length <= maxLength) return text;
        return text.replace(/<\/?[^>]+(>|$)/g, '').slice(0, 120).trim().split(/\s+/).slice(0, -1).join(' ')
    }

    if (error || audiovisualError || !videoUrl) return null;

    return (
        <li className="full-link-button">
            <button className="button-reset" onClick={() => selectVideo(videoInfo)}>
                <div className="img-container">
                    <img src={posterframeUrl} alt="" width="372" height="220" loading="lazy" />
                </div>
            </button>
            {title && (
                <h2 className="is-size-3 has-text-weight-semibold">{title}</h2>
            )}
            {transcription && (
                <p className="is-size-5">{shortenText(transcription)}...</p>
            )}
        </li>
    )
}